import { mapProductPrice, RawProductPrice } from '~/Api/Product';

import ProductIdPrice from './ProductIdPrice';

export default function mapProductIdPrice(productPrice: RawProductPrice & { productId: string }): ProductIdPrice {
	return new ProductIdPrice(productPrice.productId, mapProductPrice(productPrice));
}
